import React, { useState, useEffect } from "react";

export const CoffeeJourney: React.FC = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [showHero, setShowHero] = useState(false);

  const steps = [
    {
      name: "Getting coffee",
      icon: "",
      color: "from-amber-400 to-amber-600",
    },
    {
      name: "Pouring coffee",
      icon: "",
      color: "from-amber-500 to-amber-700",
    },
    { name: "Walking back", icon: "", color: "from-blue-400 to-blue-600" },
    { name: "Welcome back!", icon: "", color: "from-green-400 to-green-600" },
  ];

  useEffect(() => {
    // Start the sequence
    setShowHero(true);

    // Progress through each step
    const timer = setInterval(() => {
      setCurrentStep((prev) => {
        if (prev < steps.length - 1) {
          return prev + 1;
        } else {
          clearInterval(timer);
          return prev;
        }
      });
    }, 1500); // 1.5 seconds per step

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] space-y-8">
      {/* Hero Character */}
      <div
        className={`transition-all duration-1000 ${showHero ? "opacity-100 scale-100" : "opacity-0 scale-75"}`}
      >
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            Taking care of the dirty work
          </h2>
        </div>
      </div>

      {/* Progress Steps */}
      <div className="flex items-center space-x-6">
        {steps.map((step, index) => (
          <div key={index} className="flex flex-col items-center space-y-3">
            {/* Step Icon */}
            <div
              className={`w-16 h-16 rounded-full flex items-center justify-center shadow-lg transition-all duration-500 ${
                index <= currentStep
                  ? `bg-gradient-to-br ${step.color} scale-110`
                  : "bg-gray-600 scale-100"
              }`}
            >
              <span
                className={`text-xs font-semibold transition-all duration-500 ${
                  index <= currentStep ? "text-white" : "text-gray-400"
                }`}
              >
                {step.name.charAt(0)}
              </span>
            </div>

            {/* Step Label */}
            <span
              className={`text-sm font-medium text-center transition-colors duration-500 ${
                index <= currentStep ? "text-gray-800" : "text-gray-500"
              }`}
            >
              {step.name}
            </span>

            {/* Progress Indicator */}
            <div
              className={`w-8 h-1 rounded-full transition-all duration-500 ${
                index < currentStep ? "bg-green-400" : "bg-gray-600"
              }`}
            />
          </div>
        ))}
      </div>

      {/* Current Action Text */}
      <div className="text-center">
        <h3 className="text-2xl font-bold text-gray-800 mb-2">
          {steps[currentStep].name}
        </h3>
        <p className="text-gray-600">
          {currentStep === steps.length - 1
            ? "Hero has returned with your coffee and the extraction results!"
            : "Hero is on a mission..."}
        </p>
      </div>

      {/* Progress Bar */}
      <div className="w-full max-w-md bg-gray-200 rounded-full h-2">
        <div
          className="bg-gradient-to-r from-amber-400 via-blue-400 to-green-400 h-2 rounded-full transition-all duration-1000 ease-out"
          style={{ width: `${((currentStep + 1) / steps.length) * 100}%` }}
        />
      </div>
    </div>
  );
};
